import type { App } from "vue";
import CKEditor from '@ckeditor/ckeditor5-vue';
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/zh-cn.js';

export function setupCkeditor(app: App<Element>) {
  app.use(CKEditor);
}